import Vue from 'vue'
import Vuex from 'vuex'
import ApiLocalStorage from 'src/helpers/ApiLocalStorage'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    lic: ''
  },
  getters: {
    lic: state => {
      return state.lic
    }
  },
  mutations: {
    changeLic (state, lic) {
      state.lic = lic
    }
  },
  actions: {
    getLicenseChange: ({commit}) => {
      commit('changeLic', ApiLocalStorage.getUserLic())
    }
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/store.js